import * as yup from "yup";
import {requiredMessage, stringValidator} from "@/utils/yupValidators";
import {Priority} from "../choices";

yup.addMethod(yup.string, 'fourDigits', function onlyDigits(value) {
    return this.test(`test-four-digits`, gettext('Must contain four digits'), function (value) {
        return /^\d{4}$/.test(value)
    });
});

export const ticSchema = {
    ticPrefix: stringValidator.required(requiredMessage).max(1),
    ticNumber: yup.string().nullable().required(requiredMessage).fourDigits(),
};

export const triageTransportBaseSchema = {
    ...ticSchema,
    gender: stringValidator.required(requiredMessage),
    isChild: yup.boolean().required(requiredMessage),
}

export const triageSchema = {
    ...triageTransportBaseSchema,
    treatmentPriority: stringValidator.oneOf(Object.values(Priority)).required(requiredMessage),
};

export function pickTriageValues(patientData) {
    return {
        ticPrefix: patientData?.ticPrefix,
        ticNumber: patientData?.ticNumber,
        gender: patientData?.gender,
        isChild: patientData?.isChild,
        treatmentPriority: patientData?.treatmentPriority,
    };
}

export function checkIfTriageDataChanged(data, initialValues) {
    return (
        data.ticPrefix !== initialValues.ticPrefix
        || data.ticNumber !== initialValues.ticNumber
        || data.gender !== initialValues.gender
        || data.isChild !== initialValues.isChild
        || data.treatmentPriority !== initialValues.treatmentPriority
    );
}
